import { get_paywalls_state_config } from '../base';

export default get_paywalls_state_config({
    url: '/win_cost',
    title: 'Win Cost',
    template: require('./view.html'),
    is_missions_required: false,
});
